import { Dayjs } from 'dayjs';
import moment from 'moment';

import { ShipmentObj } from '@Reducers/Invoice/Type';

export interface TaxInformationOption {
  display: string;
  value: string | number;
  key: string;
}

export interface NonAccountFilterType {
  currentPage: number;
  perPage: number;
  fromDate: string;
  toDate: string;
  searchKey?: string;
  searchValue?: string;
  systems: string[];
  type: string[];
}

export interface NonAccountInvConfig {
  invoiceDate?: Dayjs | null;
  dueDate?: Dayjs | null;
  taxBreakdown?: string[];
  splitTax?: string[];
  sacCode?: string;
}

export const NonAccountSearchFilterList = [
  { label: 'Shipment No.', value: 'shipment_no' },
  { label: 'Name', value: 'name' },
  { label: 'Email', value: 'email' },
];

export const ShipmentTypeList = [
  {
    value: 'import',
    display: 'Import',
  },
  {
    value: 'export',
    display: 'Export',
  },
  {
    value: 'domestic',
    display: 'Domestic',
  },
];

export const splitTaxOptions = [
  {
    display: 'Split Tax',
    value: 'true',
  },
  {
    display: 'Full Tax',
    value: 'false',
  },
];

export const initialDateRange = {
  startDate: moment().subtract(1, 'months').startOf('day').toDate(),
  endDate: moment().endOf('day').toDate(),
};

export const initialNonAccountInvConfig: NonAccountInvConfig = {
  invoiceDate: null,
  dueDate: null,
  taxBreakdown: [],
  splitTax: [],
  sacCode: '',
};

export function convertToBoolean(input: string[] | undefined | null): boolean | null {
  if (!Array.isArray(input)) {
    return null;
  }

  if (input.length === 1) {
    const value = input[0].toLowerCase();
    if (value === 'true') return true;
    if (value === 'false') return false;
  }

  return null;
}

export function getIsWyngsMy(): boolean {
  if (typeof window === 'undefined') return false;
  const subdomain = window.location.hostname.split('.')[0];
  return subdomain === 'wyngs-my';
}

export function getTaxBreakDownObject(keys: string[] | undefined, data: TaxInformationOption[]) {
  if (!Array.isArray(keys)) {
    return undefined;
  }

  for (const key of keys) {
    const matchedItem = data.find((item: TaxInformationOption) => item.key === key);

    if (matchedItem) {
      return {
        display: matchedItem.display,
        value: matchedItem.value,
        key: matchedItem.key,
      };
    }
  }

  return undefined;
}

export function isShipmentSelectable(shipment: ShipmentObj, orgName?: string): boolean {
  if (orgName === 'Cargo Solutions Network') {
    return true;
  }
  return Boolean(shipment?.carrierDetails && shipment?.carrierDetails?.awb);
}

export function calculateNonAccountSelectedPricingSum(selectedShipments: ShipmentObj[]): number {
  if (!selectedShipments?.length) return 0;
  return selectedShipments.reduce((sum, s) => {
    const amt = Number(s?.totalAmount ?? s?.sellingPricing?.totalPricing ?? 0);
    return sum + (isNaN(amt) ? 0 : amt);
  }, 0);
}

export function validateNonAccountInvoiceConfig(
  config: NonAccountInvConfig,
  selectedCount: number,
  _isWyngsMy: boolean,
): string[] {
  const { dueDate, invoiceDate } = config;
  const missingFields: string[] = [];

  if (!invoiceDate) {
    missingFields.push('Invoice Date');
  }

  if (!dueDate) {
    missingFields.push('Due Date');
  }

  if (selectedCount === 0) {
    missingFields.push('At least one shipment');
  }

  return missingFields;
}
